/**
 * Copyright (c) oct16.
 * https://github.com/oct16
 *
 * This source code is licensed under the GPL-3.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

export const TimeCatModel = [
    ['type', 'type', { unique: false }],
    ['data', 'data', { unique: false }],
    ['relatedId', 'relatedId', { unique: false }],
    ['time', 'time', { unique: false }]
]
